function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  let chatClose = document.getElementById("shopify-chat");
  if (chatClose) chatClose.style.visibility = "hidden";

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = "none";
}
window.openCartDrawer = openCartDrawer;

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
  let chatClose = document.getElementById("shopify-chat");
  if (chatClose) chatClose.style.visibility = "visible";

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = "";
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}
window.updateCartItemCounts = updateCartItemCounts;

async function updateCartDrawer() {
  // 1) Save current state
  const oldMsgEl = document.getElementById("discount-message");
  const oldLabelEl = document.getElementById("discount-section__label");
  const oldInputEl = document.getElementById("discount-code");

  const savedMessage = oldMsgEl?.textContent || "";
  const savedMsgColor = oldMsgEl?.style.color || "";
  const savedLabelColor = oldLabelEl?.style.color || "";
  const savedInputValue = oldInputEl?.value || "";
  const savedInputBorder = oldInputEl?.style.border || "";

  // 2) Fetch & replace drawer HTML
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  // 3) Restore saved state
  const newMsgEl = document.getElementById("discount-message");
  const newLabelEl = document.getElementById("discount-section__label");
  const newInputEl = document.getElementById("discount-code");

  if (newMsgEl) {
    newMsgEl.textContent = savedMessage;
    newMsgEl.style.color = savedMsgColor;
  }
  if (newLabelEl) {
    newLabelEl.style.color = savedLabelColor;
  }
  if (newInputEl) {
    newInputEl.value = savedInputValue;
    newInputEl.style.border = savedInputBorder;
  }

  // 4) Re-attach listeners
  addCartDrawerListeners();
  discountCodeApplying();
  window.updateCartCount();
}

window.updateCartDrawer = updateCartDrawer;

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem = button.closest(".cart-lineitem");

        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  document
    .querySelectorAll(".cart-drawer-quantity-selector input[type='number']")
    .forEach((input) => {
      input.addEventListener("change", async (e) => {
        // parsiraj i validiraj novo quantity
        let newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
        e.target.value = newQuantity;

        // nađi key iz roditeljskog .cart-lineitem elementa
        const rootItem = input.closest(".cart-lineitem");
        const key = rootItem.getAttribute("data-line-item-key");

        // pošalji update na Shopify
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        // update broja u badge-ovima i reload drawer-a
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
      });
    });

  document.querySelectorAll(".cart-drawer__remove").forEach(async (btn) => {
    btn.addEventListener("click", async () => {
      const key = btn.dataset.line;
      
      // Shopify AJAX API call
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: key,      
            quantity: 0,
          }),
        });

        const cart = await res.json();

        await updateCartDrawer();
      } catch (error) {
        console.error("Error removing cart item:", error);
      }
    });
  });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer, .cart-drawer-button-close")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();
discountCodeApplying();

// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Get cart count
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);

//     // Update cart
//     await updateCartDrawer();

//     // Open cart drawer
//     // openCartDrawer();
//     openCartNotification();
//   });
// });

document.querySelectorAll('a[href$="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    if (!addRes.ok) {
      console.error("Add to cart failed");
      return;
    }

    const added = await addRes.json(); // ← single added line_item

    // 2) Update cart count (entire cart)
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // 3) Update cart drawer (your existing function)
    await updateCartDrawer();

    const qtyJustAdded = getAddedQuantityFromFormData(formData); // ← 1, or sum of items[n][quantity]

    // 4) Fill cart-notification
    // fillCartNotification(added, qtyJustAdded);
    // 5) Show notification (your existing function)
    // openCartNotification();
    openCartDrawer();

  });
});

function getAddedQuantityFromFormData(fd) {
  let total = 0;
  let found = false;

  for (const [key, val] of fd.entries()) {
    if (key === "quantity" || /^items\[\d+\]\[quantity\]$/.test(key)) {
      const n = Number(val);
      if (!Number.isNaN(n) && n > 0) {
        total += n;
        found = true;
      }
    }
  }

  return found ? total : 1;
}
window.getAddedQuantityFromFormData = getAddedQuantityFromFormData;

function fillCartNotification(addedItem, qtyJustAdded = 1) {
  const root = document.querySelector(".cart-notification");
  if (!root) return;

  const elCount = root.querySelector(".cart-notification__count");
  const elProduct = root.querySelector(".cart-notification__product");
  const elVariant = root.querySelector(".cart-notification__variant-title");

  // Variant title only if product has more than one variant and variant_title exists
  let showVariant =
    addedItem?.product_has_only_default_variant === false &&
    addedItem?.variant_title;

  // Quantity just added
  if (Array.isArray(addedItem.items)) {
    addedItem = addedItem[0];
    let count = String(qtyJustAdded);

    if (count == 1) {
      if (elCount) elCount.textContent = String(qtyJustAdded) + "x";
      if (elProduct) elProduct.textContent = addedItem?.product_title;
    } else {
      if (elCount) elCount.textContent = count;
      if (elProduct) elProduct.textContent = root.dataset?.items;
      showVariant = false;
    }
  } else {
    if (elCount) elCount.textContent = String(qtyJustAdded) + "x";
    if (elProduct) elProduct.textContent = addedItem?.product_title;
  }

  if (elVariant) {
    if (showVariant) {
      elVariant.textContent = addedItem.variant_title;
      elVariant.style.display = "";
    } else {
      elVariant.textContent = "";
      elVariant.style.display = "none";
    }
  }
}
window.fillCartNotification = fillCartNotification;

let cartNotificationTimeout;
function openCartNotification() {
  const cartNotification = document.querySelector(".cart-notification");
  if (cartNotification) {
    cartNotification.classList.add("notification-visible");

    // clear previous timer if still running
    if (cartNotificationTimeout) {
      clearTimeout(cartNotificationTimeout);
    }

    // start new timer
    cartNotificationTimeout = setTimeout(() => {
      cartNotification.classList.remove("notification-visible");
    }, 3000);
  }
}
window.openCartNotification = openCartNotification;

function discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById("apply-discount");
  if (!discountCodeApplyBtn) return;

  const wrongCodeText = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById("discount-message");
  const spinner = document.getElementById("spinner");
  const invalidCodes = new Set();

  const discountSectionLabel = document.getElementById(
    "discount-section__label"
  );
  const discountCodeInput = document.getElementById("discount-code");

  // Clear message on focus
  if (discountCodeInput && discountMessage) {
    discountCodeInput.addEventListener("focus", () => {
      discountMessage.textContent = "";
      discountMessage.style.color = "var(--neutral-1000)";
      discountSectionLabel.style.color = "var(--neutral-1000)";
      discountCodeInput.style.border = "1px solid var(--neutral-1000)";
    });
  }

  discountCodeApplyBtn.addEventListener("click", async () => {
    const discountCodeInput = document.getElementById("discount-code");
    const discountCode = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    spinner.style.display = "block";
    try {
      // Fetch current cart
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map((dc) => dc.code)
        .filter((code) => code && !invalidCodes.has(code));

      const updatedCodes = [...existingCodes, discountCode];
      const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ discount: updatedCodes.join(",") }),
      });
      const updateData = await updateRes.json();
      const newCodeEntry = updateData.discount_codes?.find(
        (dc) => dc.code === discountCode
      );

      if (!newCodeEntry?.applicable) {
        discountMessage.textContent = wrongCodeText;
        discountMessage.style.color = "#A92626";
        discountSectionLabel.style.color = "#A92626";
        discountCodeInput.style.border = "1px solid #A92626";
        invalidCodes.add(discountCode);
      } else {
        discountMessage.textContent = successCodeText;
        discountMessage.style.color = "#939E95";
        discountSectionLabel.style.color = "#939E95";
        discountCodeInput.style.border = "1px solid #939E95";
      }

      // finally refresh counts & drawer
      const updatedCart = await (await fetch("/cart.js")).json();
      updateCartItemCounts(updatedCart.item_count);
      await updateCartDrawer();
    } catch (err) {
      console.error("Discount error:", err);
      discountMessage.textContent = wrongCodeText;
      discountMessage.style.color = "#A92626";
      discountSectionLabel.style.color = "#A92626";
      discountCodeInput.style.border = "1px solid #A92626";
    } finally {
      spinner.style.display = "none";
    }
  });
}
